let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fRhTk")).then(() => parcelRequire('lPFNm'));